/* AI Poster Maker (m11 #3) — the studioCloud/desktop AI generator (components/home/AIGeneratorSection, copied
   unchanged apart from its endpoints) on brightivity.dev/posters. Off until the owner switches it on: the
   posters worker answers 503 NOT_SWITCHED_ON and this page says so. */
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TopBar } from '../app/AppShell.jsx';
import { api } from '../api/client.js';
import { Card, EmptyState, Skeleton } from '../ui/index.jsx';
import AIGeneratorSection from '../components/home/AIGeneratorSection.jsx';
import '../features/aiposter/aiposter.css';
import { useTranslation } from 'react-i18next';

export default function AiPosterPage() {
  const { t } = useTranslation('bv');
  const [params] = useSearchParams();
  const ref = useRef(null);
  const [state, setState] = useState(null); // null = checking, 'on' | 'off'
  useEffect(() => {
    let live = true;
    api('/posters/health', { auth: false }).then((r) => { if (live) setState(r.ok && r.data && r.data.enabled ? 'on' : 'off'); });
    return () => { live = false; };
  }, []);
  return (
    <div className="bv-content bv-aiposter" data-testid="ai-poster-page">
      <TopBar title={t('ai.title')} subtitle={t('ai.subtitle')} />
      {state === null ? <Skeleton height={320} radius={24} />
        : state === 'off' ? (
          <Card><EmptyState icon="sparkle" title={t('ai.off.title')}>{t('ai.off.body')}</EmptyState></Card>
        ) : (
          <div className="bv-aiposter__body" data-tour="generator-form"><AIGeneratorSection sectionRef={ref} initialPrompt={params.get('prompt') || ''} /></div>
        )}
    </div>
  );
}
